/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    getUserRole,
    SaveDeductionTemplate,
    GetdeductionTemplatedetailsByTemplateID,
    EditDeductionTemplate,
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    getAvailableDeductionTypes,
    GetAllDeductionTemplateData
};

async function getUserRole(groupID, operationEntityID, level) {
    const response = await CommonGet('/api/Role/GetRolesByRoleLevel', 'roleLevelID=' + parseInt(level) + '&groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    if (response.data != null) {
        return response.data;
    }
    return null;
}

async function GetdeductionTemplatedetailsByTemplateID(id) {
    const response = await CommonGet('/api/DeductionTemplateWeb/GetdeductionTemplatedetailsByTemplateID', 'deductionTemplateID=' + parseInt(id));
    if (response.data != null) {
        return response.data;
    }
    return null;
}

async function SaveDeductionTemplate(model) {
    const response = await CommonPost('/api/DeductionTemplateWeb/SaveDeductionTemplate', null, model);
    return response;
}

async function EditDeductionTemplate(model) {
    const response = await CommonPost('/api/DeductionTemplateWeb/UpdateDeductionTemplate', null, model);
    return response;
}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function getAvailableDeductionTypes(filterModel) {
    var response = await CommonPost('/api/Deductiontype/GetAllDeductionTypes', null, filterModel);
    return response.data;
}

async function GetAllDeductionTemplateData(groupID, operationEntityID) {
    var response = await CommonPost('/api/DeductionTemplateWeb/GetDeductionTemplate', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID);
    return response.data;
}

